import React from 'react'
import WebContentView from '../../WebContentView'
import { useSelector } from 'APP/Hooks/redux'
import { useConsentForm } from '../hooks/useConsentForm'
import { Dimensions } from 'react-native'
import { StyledConsentView } from '../styles'

const { height: screenHeight } = Dimensions.get('window')

const ConsentForm = () => {
  const { consentUrl } = useConsentForm()
  const { requestRunning } = useSelector((state: any) => state.family)

  return (
    <StyledConsentView height={screenHeight * 0.6}>
      <WebContentView
        uri={consentUrl}
        busy={requestRunning}
        screen="consent"
        bordered
        testID="CONSENT_FORM"
      />
    </StyledConsentView>
  )
}

export default ConsentForm
